function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M9.143,32C4.093,32,0,35.325,0,39.429A6.593,6.593,0,0,0,2.036,44.1,9.086,9.086,0,0,1,.079,47.518a.284.284,0,0,0-.054.311A.28.28,0,0,0,.286,48a8.168,8.168,0,0,0,5.021-1.836,10.892,10.892,0,0,0,3.836.693c5.05,0,9.143-3.325,9.143-7.429S14.193,32,9.143,32ZM4.571,40.571a1.143,1.143,0,1,1,1.143-1.143A1.142,1.142,0,0,1,4.571,40.571Zm4.571,0a1.143,1.143,0,1,1,1.143-1.143A1.142,1.142,0,0,1,9.143,40.571Zm4.571,0a1.143,1.143,0,1,1,1.143-1.143A1.142,1.142,0,0,1,13.714,40.571Z",
  transform: "translate(0 -32)"
});

function SvgCommentDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.286,
    height: 16,
    viewBox: "0 0 18.286 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentDots);
export default __webpack_public_path__ + "static/media/comment-dots.8a4bb4b2.svg";
export { ForwardRef as ReactComponent };